/* eslint-disable max-len */

import React, {useEffect} from 'react'
import { motion } from 'framer-motion';
import ReactModal from 'react-modal';
import { Link } from 'react-router-dom';
import AcceptRejectBlock from '../../Components/OrderSummary/AcceptRejectBlock';
import { PriceHandler } from '../../redux/helper/CamelCase'
import { GenerateDateandTime, GenerateDateFormat, generateDateWithTime } from '../../redux/helper/DateConverter'
import AcceptReject from './AcceptReject';

function OrderListing({type,handleChange,Items,sort,setsort,setmodalType,modalType,setselectedID}) {
    const order_Status={
        1:'Pending',
        2:'In-process',
        3:'Approved',
        4:'Out for delivery',
        5:'Partially delivered',
        6:'Deliverd',
        7:'Completed',
        8: 'Cancelled',
        9:'Cancelled'
    }

    const checkAssistant = ()=>{
        const item = JSON.parse(localStorage.getItem('user'))?.profile?.logged_in_user;
        return item==='distributor'?false:true;
    }

    return (
        <>
            
            <div className="tab-content" id="pills-tabContent">
                <div className="overflow-auto mt-[18px] sidebar dropdown-menu pb-7" style={{zIndex:'9', height: 'calc(100vh - 297px)'}}>
                    <table className="w-full table-auto relative">
                        <thead className='sticky top-0 z-[2]'>
                            <tr className="bg-[#555259] h-10">
                                <th 
                                    className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]"
                                    scope="col">
                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                        Order Number
                                    </span>
                                </th>
                                <th scope="col" className="py-2.5 px-7 min-w-[175px]">
                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                        Order Created
                                        {type==='order' &&
                                        <a href="javascript:void(0)" className="pl-[5px]">
                                            <motion.img
                                                animate={{ rotate: sort === 'created_at+asc' ? 180 : 0 }}
                                                className={`${sort === 'created_at+desc' ? 'image-rotate' : ''}`}
                                                src="/images/sort.svg"
                                                alt="icon"
                                                onClick={() => {
                                                    if (sort === 'created_at+asc') {
                                                        setsort('created_at+desc');
                                                    } else if (sort === 'created_at+desc') {
                                                        setsort('created_at+asc');
                                                    } else {
                                                        setsort('created_at+asc');
                                                    }
                                                    // setCurrentPage(1);
                                                    // setLoading(true);
                                                }}
                                            />
                                        </a>}
                                    </span>
                                </th>
                                <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                        Indent Number
                                    </span>
                                </th>
                                <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                        Acceptance No
                                    </span>
                                </th>
                                <th scope="col" className="py-2.5 px-7 min-w-[177px] text-center flex justify-center items-center pt-4">
                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                        Order Type
                                    </span>
                                </th>
                                <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                        No. of Items
                                    </span>
                                </th>
                                {type==='order'?
                                    <>
                                        <th scope="col" className="py-2.5 px-7 min-w-[165px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Order Status
                                                <a href="javascript:void(0)" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sort === 'status+asc' ? 180 : 0 }}
                                                        className={`${sort === 'status+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sort === 'status+asc') {
                                                                setsort('status+desc');
                                                            } else if (sort === 'status+desc') {
                                                                setsort('status+asc');
                                                            } else {
                                                                setsort('status+asc');
                                                            }
                                                            // setCurrentPage(1);
                                                            // setLoading(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Total Amount
                                            </span>
                                        </th>
                                    </>:
                                    <>
                                        <th scope="col" className="py-2.5 px-7 min-w-[165px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Net Total
                                                {/* <a href="#" className="pl-[5px]">
                                                    <img src="images/Group-9083.svg" alt="" />
                                                </a> */}
                                            </span>
                                        </th>
                                        <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Gross Total
                                            </span>
                                        </th>
                                    </>}
                                {/* <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                        Payment Due
                                    </span>
                                </th>
                                <th scope="col" className="py-2.5 px-7 min-w-[208px]">
                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                        Expected Dispatch
                                        <a href="#" className="pl-[5px]">
                                            <img src="images/Group-9083.svg" alt="" />
                                        </a>
                                    </span>
                                </th>  */}
                                <th scope="col" 
                                    className="py-2.5 px-7 min-w-[152px] rounded-tr-lg rounded-br-lg sm:sticky top-0 right-0 bg-[#555259]">
                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                        Actions
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* <!-- active row --> */}
                            {Items.length>0 &&Items.map((item,i)=>(
                                <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]" key={i}>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 flex justify-center items-center pt-4"          style={{background:'rgba(255, 255, 255, 0.45)',backdropFilter:'blur(5.5px)'}}>
                                        {item?.order_initial_number}
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-left">
                                        {generateDateWithTime(item?.created_at)}
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                        {item?.order_number}
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                        {item?.order_acceptance_number||'-'}
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                        {item?.order_type}
                                    </td>
                                    <td className="text-sm font-normal py-2.5 px-7 text-center">
                                        {item?.total_items}
                                    </td>
                                    <>{type==='order'?<>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-left">
                                            {order_Status[String(item?.status)]}
                                        </td>
                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                            {PriceHandler(item?.total_price)}
                                        </td>
                                    </>
                                        :<>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-left">
                                                {PriceHandler(item?.net_ammount)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-left">
                                                {PriceHandler(item?.total_price)}
                                            </td>
                                        </>
                                    }
                                    </>
                                    {/* <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                        -
                                    </td>
                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                        -
                                    </td> */}
                                    <>
                                        {type==='draft'?
                                            <td className="py-2.5 px-7 sm:sticky right-0 bg-[#ffffffe6] z-[1]">
                                                <div className="flex items-center">
                                                    {!checkAssistant() &&<button
                                                        disabled={checkAssistant()}
                                                        onClick={()=>{
                                                            setmodalType('Accept');
                                                            setselectedID(item.order_number)
                                                            
                                                        }}
                                                        type="button" className="font-semibold text-sm text-[#206C00] bg-[#CFF7BE] rounded-lg w-[72px] h-[34px]">
                                                        Accept
                                                    </button>}
                                                    <>{!checkAssistant() &&<button 
                                                        disabled={checkAssistant()}
                                                        onClick={()=>{
                                                            setmodalType('Reject');
                                                            setselectedID(item.order_number)
                                                            
                                                        }}

                                                        type="button" className="font-semibold text-sm text-[#800005] bg-[#F2777C] rounded-lg mx-2.5 w-[72px] h-[34px]">
                                                        Reject
                                                    </button>}</>
                                                    <button type="button" className="font-semibold text-sm text-[#303030] bg-[#A5A5A5] rounded-lg w-[72px] h-[34px]">
                                                        <Link to={`/orders/${item.order_number}/view`}>View</Link>
                                                    </button>
                                                </div>
                                            </td>
                                            :
                                            <td className="py-2.5 px-7 sm:sticky right-0 z-[1]" style={{background:'rgba(255, 255, 255, 0.45)',backdropFilter:'blur(5.5px)'}}>
                                                <div className="flex items-center">
                                                    <Link to={`/orders/${item.order_number}/view`}>
                                                        <button type="button" className="font-semibold text-sm text-[#303030] bg-[#A5A5A5] rounded-lg w-[72px] h-[34px]">
                                                            View
                                                        </button>
                                                    </Link>
                                                </div>
                                            </td>
                                        }
                                    </>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
        
            </div>
        </>
    )
}

export default OrderListing